import React, { useState } from 'react';
import RecipeScheduleModal from '../planner/RecipeScheduleModal';
import './RecipeCard.css';

const RecipeCard = ({ recipe, onClick, onScheduleSuccess }) => {
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  const handleScheduleClick = (e) => {
    e.stopPropagation(); // Prevent card click event
    setShowScheduleModal(true);
  };

  const handleScheduleModalClose = () => {
    setShowScheduleModal(false);
  };

  const handleScheduleSuccess = () => {
    setShowScheduleModal(false);
    if (onScheduleSuccess) {
      onScheduleSuccess();
    }
  };

  return (
    <>
      <div className="recipe-card" onClick={() => onClick(recipe)}>
        <div className="recipe-image">
          {recipe.image_url ? (
            <img src={recipe.image_url} alt={recipe.title} />
          ) : (
            <div className="placeholder-image">
              <span>🍽️</span>
            </div>
          )}
          <button 
            className="schedule-button"
            onClick={handleScheduleClick}
            title="Schedule this recipe"
          >
            +
          </button>
        </div>
        <div className="recipe-content">
          <h3 className="recipe-title">{recipe.title}</h3>
          <div className="recipe-meta">
            {recipe.prep_time && (
              <span className="meta-item">⏱️ {recipe.prep_time} min</span>
            )}
            {recipe.servings && (
              <span className="meta-item">👥 {recipe.servings} servings</span>
            )}
          </div>
          {recipe.description && (
            <p className="recipe-description">{recipe.description}</p>
          )}
          <div className="recipe-tags">
            {recipe.tags && recipe.tags.map((tag, index) => (
              <span key={index} className="tag">{tag}</span>
            ))}
          </div>
        </div>
      </div>

      <RecipeScheduleModal
        isOpen={showScheduleModal}
        onClose={handleScheduleModalClose}
        recipe={recipe}
        onScheduleSuccess={handleScheduleSuccess}
      />
    </>
  );
};

export default RecipeCard;